import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";

import localizeHref from "../../../lib/multilingual/localizeHref";
import Breadcrumb from "../common/Breadcrumb";
import { useProductDetailsContext } from "./ProductDetailsProvider";
import { ProductBySlugNonNullable } from "@/common/contracts/pdp.contracts";

// SHORT TERM SOLUTION
const WHOPPAH_SERVICES = ["9AH4AFP7ETSK", "FQUWQXPKKJ70", "FOMQ6V1WWPFU"];

type ProductDetailsBreadcrumbsItems = {
  label: string;
  href?: string;
}[];

type ProductDetailsBreadcrumbsProps = {
  product: ProductBySlugNonNullable;
};

export const ProductDetailsBreadcrumbs = ({
  product,
}: ProductDetailsBreadcrumbsProps) => {
  const { t } = useTranslation();
  const { locale } = useRouter();
  const { showOriginalText } = useProductDetailsContext();

  const items: ProductDetailsBreadcrumbsItems = [
    { label: showOriginalText ? product.original_title : product.title },
  ];

  if (WHOPPAH_SERVICES.includes(product.identifier)) {
    items.unshift({
      label: t("common:common_services"),
      href: "/services",
    });
  } else {
    for (const category of product.categories) {
      items.unshift({
        label: category.title,
        // category route here is in dutch, do we change it to current locale
        href: localizeHref(`/${category?.route}`, "nl", locale),
      });
    }
  }

  return (
    <Breadcrumb items={items} horizontalScroll={true} visibleOnMobile={true} />
  );
};
